import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AjaxService } from 'src/app/services/ajax.service';
import { CommonService } from 'src/app/services/common.service';
import { serverUrl } from 'src/environments/environment';

@Component({
  selector: 'app-bulk-veh-upld',
  templateUrl: './bulk-veh-upld.component.html',
  styleUrls: ['./bulk-veh-upld.component.scss'],
})
export class BulkVehUpldComponent implements OnInit {
@Input() name: string;
  constructor( private ajax: AjaxService,private commonService : CommonService, private modelCtrl: ModalController) { }

  ngOnInit() {}

   downloadExcel(): void {
    const link = document.createElement('a');
    link.href = `assets/excel_bulk/bulk${this.name}.xls`;
    link.download = `bulk${this.name}.xls`;
    link.click();
  }
formData: FormData = new FormData();
  fileName: string = ''; 
   onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.fileName = file.name;
      this.formData.append('file', file);
      let obj = { "username": `${localStorage.ca}`,  "companyID":  `${localStorage.corpId}` }
      this.formData.append('data', JSON.stringify(obj));
       for (const pair of(this.formData as any).entries()) {
      console.log(pair[0], pair[1]);
    }
      console.log(this.formData); 
      
    }
  }
cancel(){
  this.modelCtrl.dismiss();
}
submitFile(): void {
    if (this.formData.has('file')) {
        const arr = ["bulkvehicle", "bulksim", "bulkdevice"];
          const baseName = this.fileName.split('.')[0].toLowerCase(); // ignore case

          // Check if any of the allowed names is included in the filename
          const isValid = arr.some(name => baseName.includes(name.toLowerCase()));

          if (!isValid) {
            this.commonService.presentToast(
              "File format error: Only the specified sample Excel format is supported. Modified files cannot be uploaded."
            );
            return null;
          }
      this.commonService.presentLoader();
      let url = '';
     if(this.name == "vehicle"){
         url = serverUrl.web + "/VehicleController/vehiclebulkupload"
     }else if(this.name == "device"){
      url = serverUrl.web + "/device/devicebulkupload"
     }else{
      url = serverUrl.web + "/simcard/simbulkupload"
     }
     
      this.ajax.ajaxPostMethod(url, this.formData).subscribe((res) => {
        console.log("res",res);
        this.commonService.dismissLoader();
        if(res.success == true){
          this.commonService.presentToast(res.message)
          this.formData = new FormData();
          this.fileName = '';
          const fileInput = document.getElementById('fileInput') as HTMLInputElement;
          if (fileInput) fileInput.value = '';
          this.modelCtrl.dismiss("saved");
        }else{
          this.commonService.presentToast(res.errors[0].message)
        }
       
      });
    } 
    else {

     this.commonService.presentToast("No file selected for upload")
    }
  }
}
